import { useEffect, useRef } from 'react';

import {
    InfiniteScroll,
    type InfiniteScrollRef
} from '@/components/composite/InfiniteScroll/InfiniteScroll';

import { SparksMessageBubble } from './SparksMessageBubble';

export type SparksMessage = {
    id: string;
    role: 'user' | 'agent';
    content: string;
};

type SparksConversationProps = {
    messages: SparksMessage[];
};

export function SparksConversation({ messages }: SparksConversationProps) {
    const scrollRef = useRef<InfiniteScrollRef>(null);

    useEffect(() => {
        if (messages.length > 0) {
            requestAnimationFrame(() => {
                scrollRef.current?.scrollToBottom();
            });
        }
    }, [messages.length]);

    return (
        <div className="flex-1 overflow-hidden px-3.5">
            <InfiniteScroll
                ref={scrollRef}
                data={messages}
                hasMore={false}
                renderItem={(message) => (
                    <div className="py-1.5">
                        <SparksMessageBubble message={message} />
                    </div>
                )}
            />
        </div>
    );
}
